<div class="d-flex align-items-center justify-content-center min-vh-100">
  <app-empty-state icon="bi-shield-lock" [title]="errorhandlerData?.title ?? 'Access denied'" [message]="errorhandlerData?.description ?? ''">
    @if (landingDestination(); as destination) {
      <a class="btn btn-primary" [routerLink]="destination.route">Go to {{ destination.label }}</a>
    }
  </app-empty-state>
</div>
